export function calculateTotalAmountPayable(
    numberOfYears: number,
    monthlyRepaymentRate: number
): number {
    return numberOfYears * monthlyRepaymentRate * 12;
}
